/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState } from 'react';
import SelectBox from '@components/form/SelectBox';

import useApi from '@/hooks/useApi';
import { MsB2b } from '@api/ms-b2b';
import PropTypes from 'prop-types';

const propTypes = {
  editable: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  isRequired: PropTypes.bool,
  multiple: PropTypes.bool,
  hasError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  onChange: PropTypes.func,
  hideLabel: PropTypes.bool,
  isDropdown: PropTypes.bool,
  customFilter: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  inputContainerStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object,
  ]),
  extra_values: PropTypes.array,
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

const defaultProps = {
  editable: true,
  isRequired: false,
  multiple: false,
  hasError: false,
  isDropdown: false,
  onChange: () => {},
  hideLabel: false,
  customFilter: {},
  inputContainerStyle: {},
  value: '',
  extra_values: [],
  label: 'Market Type',
  placeholder: 'Select Market Type',
};

const limit = 10;

let customFilter = null;

const MarketTypeSearch = (props) => {
  const {
    editable = true,
    isRequired = false,
    multiple = false,
    isDropdown = false,
    hasError = false,
    hideLabel = false,
    inputContainerStyle = {},
    value = '',
    extra_values = [],
    label = 'Market Type',
    placeholder = 'Select Market Type',
  } = props;

  const [loading, setLoading] = useState({
    initial: false,
    loadMore: false,
  });
  const [options, setOptions] = useState([]);
  const [skip, setSkip] = useState(0);

  const getMarketType = useApi(MsB2b.getMarketType);

  if (props.customFilter) {
    customFilter = JSON.parse(JSON.stringify(props.customFilter));
  }

  const onSearch = async (val, newSkip = 0) => {
    if (!val) {
      setSkip(0);
    }
    if (newSkip) {
      setLoading({ ...loading, loadMore: true });
    } else {
      setLoading({ ...loading, initial: true });
    }
    try {
      let filter = {};
      if (customFilter) {
        filter = customFilter;
      }
      if (val) {
        filter.code = { $regex: val, $options: 'i' };
      }
      if (!val && filter.code) {
        delete filter.code;
      }
      const response = await getMarketType.request({
        params: {
          filter: filter,
          skip: newSkip,
          limit: limit,
        },
      });
      if (response.status == 200 && response?.data?.data?.length) {
        const result = response.data.data.map((item) => {
          if (item._id) {
            item.id = item._id;
          }
          item.code = item.code.toUpperCase();
          return item;
        });

        if (newSkip) {
          setOptions(extra_values.concat(options.concat(result)));
        } else {
          setOptions(extra_values.concat(result));
        }
      } else {
        if (!newSkip) {
          setOptions([]);
        }
      }

      if (newSkip) {
        setLoading({ ...loading, loadMore: false });
      } else {
        setLoading({ ...loading, initial: false });
      }
    } catch (error) {
      if (newSkip) {
        setLoading({ ...loading, loadMore: false });
      } else {
        setLoading({ ...loading, initial: false });
      }
    }
  };

  return (
    <SelectBox
      {...props}
      label={label}
      options={options}
      value={{
        ...value,
        code: value?.code ? value?.code.toUpperCase() : '',
      }}
      placeholder={
        loading.initial || loading.loadMore ? 'Loading...' : placeholder
      }
      trackBy="id"
      labelKey="code"
      isRequired={isRequired}
      multiple={multiple}
      editable={editable && !loading.initial}
      hideLabel={hideLabel}
      isDropdown={isDropdown}
      inputContainerStyle={inputContainerStyle}
      hasError={hasError}
      loading={loading.initial}
      loadingCallback={loading.loadMore}
      withCallback={true}
      withLoadMore={true}
      loadMoreEmpty={skip >= options.length}
      searchCallback={(val) => {
        setSkip(0);
        onSearch(val);
      }}
      onLoadMore={(val) => {
        const newSkip = skip + 10;
        setSkip(newSkip);
        onSearch(val, newSkip);
      }}
      onChange={(val) => {
        props.onChange(val);
      }}
      onReady={() => {
        setSkip(0);
        onSearch();
      }}
    />
  );
};

MarketTypeSearch.propTypes = propTypes;
MarketTypeSearch.defaultProps = defaultProps;

export default MarketTypeSearch;
